// Reduced-motion check.
// Mounted by: markChoreography.ts (and any other motion module that needs the same check).
// A single source of truth so every motion module bails out the same way.

export function prefersReducedMotion(): boolean {
  // matchMedia is absent during server-side rendering / some test environments — treat
  // that as "motion is fine" rather than throwing, since this file has no DOM of its own.
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
